import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-92">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-93">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-94">
          Si eres docente, déjanos hacerte una pregunta:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-3 text-center" data-id="element-95">
          ¿Sientes que pasas horas adaptando actividades porque los materiales
          tradicionales no funcionan para todos tus estudiantes?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-96">
          <p data-id="element-97"></p>
          <p data-id="element-98"></p>
          <p className="font-bold" data-id="element-99">
            <span className="px-1 bg-[#FFFFFF]" data-id="element-100">
              La realidad es que muchos materiales educativos suelen ser
              visualmente saturados, difíciles de comprender y poco accesibles
              para algunos alumnos.
            </span>
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-101">
          Y entre planificaciones, clases, reuniones y evaluaciones, terminas
          invirtiendo horas intentando adaptar actividades para que todos puedan
          participar.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-102">
          La inclusión educativa no debería significar trabajar el triple.
        </p>
      </div>
    </section>;
}